import { useEffect, useState } from 'react'

const PHONE_BREAKPOINT = 768
const MOBILE_BREAKPOINT = 1024

const useWidthBelow = (breakpoint: number) => {
  const [matches, setMatches] = useState(window.innerWidth < breakpoint)

  useEffect(() => {
    const check = () => {
      setMatches(window.innerWidth < breakpoint)
    }
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [breakpoint])

  return matches
}

/** Compact chrome (nav, drawers). Tablets in portrait are included. */
export const useIsMobile = () => useWidthBelow(MOBILE_BREAKPOINT)

/** Phone-only layouts. Tablets keep denser office grids. */
export const useIsPhone = () => useWidthBelow(PHONE_BREAKPOINT)
